import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=fd098cce&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&async=true&lang=js&"
export * from "./MyProfile.vue?vue&type=script&async=true&lang=js&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=fd098cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd098cce",
  null
  
)

export default component.exports